import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconTrash = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M25.45 2.562c-2.229.381-4.093 2.097-4.66 4.286-.13.506-.142.723-.166 3.087l-.025 2.542-8.3.018L4 12.512l-.303.14c-.167.077-.443.28-.615.452-.965.965-.684 2.59.552 3.196l.366.18 2.768.019c1.522.01 2.768.04 2.768.068 0 .32 3.342 39.953 3.393 40.233.17.942.486 1.657 1.078 2.44.855 1.132 2.144 1.93 3.495 2.166.494.086 2.258.098 14.498.098s14.004-.012 14.499-.098c1.35-.236 2.639-1.034 3.494-2.166.582-.77.91-1.511 1.078-2.44.05-.278 3.393-39.918 3.393-40.237 0-.025 1.246-.054 2.768-.064L60 16.48l.366-.18a2.014 2.014 0 0 0 1.005-2.506c-.163-.435-.637-.943-1.066-1.141L60 12.512l-8.3-.017-8.299-.018-.026-2.542c-.023-2.364-.035-2.581-.166-3.087-.505-1.955-2.018-3.517-4.012-4.14l-.573-.18-6.432-.01c-3.538-.005-6.571.015-6.742.044m.335 4.054c-.48.173-.896.608-1.07 1.122-.052.148-.075.933-.075 2.48v2.262h14.72l-.005-2.288c-.003-1.582-.028-2.35-.08-2.492-.133-.36-.471-.771-.79-.958l-.309-.182-6.08-.014c-4.86-.01-6.126.003-6.311.07M13.568 16.57c0 .32 3.278 39.231 3.326 39.488.12.628.527 1.127 1.084 1.326.343.123 27.706.121 28.05-.002.569-.203 1.02-.793 1.107-1.446.032-.246 3.297-39.232 3.297-39.373 0-.028-8.294-.051-18.432-.051-10.858 0-18.432.024-18.432.058m12.314 9.117c-.577.145-1.01.5-1.322 1.083l-.144.27v19.904l.15.288c.21.406.614.8.996.971.466.21 1.228.206 1.652-.007.366-.185.783-.586.969-.932l.137-.256.017-9.885c.019-11.106.057-10.225-.473-10.814a2.02 2.02 0 0 0-1.982-.622m11.311-.021c-.384.08-.78.325-1.087.674-.496.563-.462-.266-.443 10.783l.017 9.885.137.256c.186.346.603.747.97.932.423.213 1.185.217 1.651.007.382-.171.786-.565.997-.971l.149-.288.017-9.815q.015-9.813-.05-10.058c-.15-.557-.763-1.204-1.272-1.341-.385-.104-.783-.127-1.086-.064" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconTrash.displayName = 'IconTrash';